const REFUSAL_TAGS = {
  ACTIVITY_NOT_SUPPORTED: 'ACTIVITY_NOT_SUPPORTED',
  COMPANY_CLOSED: 'COMPANY_CLOSED',
  COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER:
    'COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER',
  COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER:
    'COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER',
  COMPANY_NOT_OWNED_BY_USER: 'COMPANY_NOT_OWNED_BY_USER',
  COMPANY_SITUATION_NOT_SUPPORTED: 'COMPANY_SITUATION_NOT_SUPPORTED',
  CUSTOM: 'CUSTOM',
  FORGED_DOCUMENT: 'FORGED_DOCUMENT',
  IDENTITY_THEFT: 'IDENTITY_THEFT',
  LEGAL_FORM_NOT_SUPPORTED: 'LEGAL_FORM_NOT_SUPPORTED',
  // DEPRECATED
  LOCATION_NOT_SUPPORTED: 'LOCATION_NOT_SUPPORTED',

  NO_ACTIVE_ESTABLISHMENT: 'NO_ACTIVE_ESTABLISHMENT',

  SUSPICIOUS_BEHAVIOUR: 'SUSPICIOUS_BEHAVIOUR',

  SUSPICIOUS_CHANGE_OF_EXECUTIVES: 'SUSPICIOUS_CHANGE_OF_EXECUTIVES',

  SUSPICIOUS_RECENT_LIQUIDATIONS: 'SUSPICIOUS_RECENT_LIQUIDATIONS',
  USER_NOT_ALLOWED_TO_WORK_IN_FRANCE: 'USER_NOT_ALLOWED_TO_WORK_IN_FRANCE',
  USER_TAX_RESIDENCY_COUNTRY_NOT_SUPPORTED:
    'USER_TAX_RESIDENCY_COUNTRY_NOT_SUPPORTED',
};

const kycRefusalTags = Object.values(REFUSAL_TAGS);

const kycRefusalMessage = {
  en: {
    ACTIVITY_NOT_SUPPORTED:
      "Unfortunately, we cannot open your bank account because Shine can't support the activity type of your company yet.\n\n" +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    COMPANY_CLOSED:
      'Unfortunately, we cannot open your bank account because your company is closed.',
    COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER:
      "Unfortunately, we cannot open your bank account because we currently don't support companies where one of the shareholders is a moral person.\n\n" +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER:
      'Unfortunately, we cannot open your bank account because your company has more than one majority beneficiary.\n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    COMPANY_NOT_OWNED_BY_USER:
      'Unfortunately, we cannot open your bank account because you are not the manager of the company you have subscribed.\n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    CUSTOM:
      '{0}\n\n' +
      'After analysis of your application and in conformity with our Terms and Conditions, we are unfortunately unable to open your account. \n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    DEFAULT:
      'After analysis of your application and in conformity with our Terms and Conditions, we are unfortunately unable to open your account. \n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    FORGED_DOCUMENT:
      'After analysis of your application and in conformity with our Terms and Conditions, we are unfortunately unable to open your account.' +
      'Among the documents that you provided to us, we detected that one of them was unfortunately not in conformity with our controls.' +
      'We are under strict rules, and we are no longer able to continue our business relationship with you.',
    LEGAL_FORM_NOT_SUPPORTED:
      "Unfortunately, we cannot open your bank account because Shine can't support the legal form of your company yet.\n\n" +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    LOCATION_NOT_SUPPORTED:
      'Unfortunately, we cannot open your bank account because Shine doesn’t support the department of your company yet.\n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
    NO_ACTIVE_ESTABLISHMENT:
      'Unfortunately, we cannot open your bank account because your company has no active establishment.',
    USER_NOT_ALLOWED_TO_WORK_IN_FRANCE:
      'Your documents indicate that you are not allowed to work and start a business in France. Unfortunately, we are unable to open your bank account.\n\n' +
      'We are continuing our work to be able to welcome all entrepreneurs who would like to open a Shine bank account and we are sincerely sorry to be unable to welcome you this time.',
  },
  fr: {
    ACTIVITY_NOT_SUPPORTED:
      "Après étude de votre dossier, nous sommes dans le regret de vous annoncer que nous ne sommes pas en mesure de procéder à l'ouverture de votre compte Shine.\n\n" +
      "En effet, l'activité de votre entreprise ne fait pas partie des activités que nous acceptons.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    COMPANY_CLOSED:
      'Nous ne pouvons malheureusement pas poursuivre l’ouverture de votre compte bancaire car votre entreprise n’est plus en activité.',
    COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER:
      'Nous ne pouvons malheureusement pas poursuivre l’ouverture de votre compte bancaire car Shine n’est pas encore en mesure d’accueillir d’entreprise où l’un des actionnaires est une personne morale.\n\n' +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER:
      "Nous ne pouvons malheureusement pas poursuivre l'ouverture de votre compte bancaire car votre entreprise comprend plus d'un bénéficiaire majoritaire.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    COMPANY_NOT_OWNED_BY_USER:
      "Nous ne pouvons malheureusement pas poursuivre l'ouverture de votre compte bancaire car vous n'êtes pas le·la gérant·e de l'entreprise que vous avez renseignée.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    CUSTOM:
      '{0}\n\n' +
      "Nous avons bien analysé votre dossier et malheureusement, nous ne pouvons pas poursuivre l’ouverture de votre compte conformément à nos Conditions Générales d'Utilisation.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    DEFAULT:
      "Nous avons bien analysé votre dossier et malheureusement, nous ne pouvons pas poursuivre l’ouverture de votre compte conformément à nos Conditions Générales d'Utilisation.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    FORGED_DOCUMENT:
      "Après étude de votre dossier, nous sommes dans le regret de vous annoncer que nous ne sommes pas en mesure de procéder à l'ouverture de votre compte Shine.\n\n" +
      "En effet, parmi les documents que vous nous avez transmis au moment de votre inscription, nous avons détecté que l'un d'entre eux n'était malheureusement pas conforme avec nos contrôles.\n\n" +
      'Nous sommes soumis à des règles strictes, et nous ne sommes plus en mesure de poursuivre notre relation commerciale avec vous.\n\n',
    LEGAL_FORM_NOT_SUPPORTED:
      "Nous ne pouvons malheureusement pas poursuivre l'ouverture de votre compte bancaire car Shine n'est pas encore en mesure d'accueillir la forme juridique de votre entreprise.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    LOCATION_NOT_SUPPORTED:
      "Nous avons bien analysé votre dossier et malheureusement nous ne sommes pas encore en mesure d'accepter ou de créer une entreprise localisée dans votre département.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
    NO_ACTIVE_ESTABLISHMENT:
      'Nous ne pouvons malheureusement pas poursuivre l’ouverture de votre compte bancaire car aucun établissement de votre entreprise n’est actif. Cela s’apparente à une cessation d’activité.',
    USER_NOT_ALLOWED_TO_WORK_IN_FRANCE:
      "Vos documents indiquent que vous n'êtes pas autorisé·e à travailler et à créer une entreprise en France. Nous ne pouvons donc malheureusement pas poursuivre l'ouverture de votre compte bancaire.\n\n" +
      'Nous continuons à travailler pour pouvoir un jour accepter tous les entrepreneurs qui souhaitent ouvrir un compte chez Shine et sommes sincèrement désolés de ne pas pouvoir vous accueillir cette fois-ci.',
  },
};

/**
 * Only differences between email messages and kycRefusalMessage
 */
const kycRefusalUrls = {
  en: {
    ACTIVITY_NOT_SUPPORTED: {
      label: 'To get more information, you can read this article.',
      url: 'https://help.shine.fr/fr/articles/3606432-quelles-sont-les-activites-acceptees-sur-shine',
    },
    DEFAULT: null,
  },
  fr: {
    ACTIVITY_NOT_SUPPORTED: {
      label: 'Quelles sont les activités acceptées sur Shine ?',
      url: 'https://help.shine.fr/fr/articles/3606432-quelles-sont-les-activites-acceptees-sur-shine',
    },
    DEFAULT: null,
  },
};

const kycRefusalTagLabel = {
  en: {
    ACTIVITY_NOT_SUPPORTED: 'Activity not supported',
    COMPANY_CLOSED: 'Company closed',
    COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER: 'Moral person as shareholder',
    COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER:
      'The company has more than one effective shareholder',
    COMPANY_NOT_OWNED_BY_USER: 'The company is not run by the user',
    COMPANY_SITUATION_NOT_SUPPORTED: "The company's situation is not supported",
    CUSTOM: 'Custom',
    FORGED_DOCUMENT: 'Forged document(s)',
    IDENTITY_THEFT: 'Identity theft',
    LEGAL_FORM_NOT_SUPPORTED: 'Legal form not supported',
    LOCATION_NOT_SUPPORTED: 'Unsupported location',
    NO_ACTIVE_ESTABLISHMENT: 'No active establishment',
    SUSPICIOUS_BEHAVIOUR: 'Suspicious behaviour',
    SUSPICIOUS_CHANGE_OF_EXECUTIVES: 'Suspicious change of executive(s)',
    SUSPICIOUS_RECENT_LIQUIDATIONS: 'Suspicious recent liquidation(s)',
    USER_NOT_ALLOWED_TO_WORK_IN_FRANCE: 'User not allowed to work in France',
    USER_TAX_RESIDENCY_COUNTRY_NOT_SUPPORTED:
      'User country of tax residence not supported',
  },
  fr: {
    ACTIVITY_NOT_SUPPORTED: 'Activité non supportée',
    COMPANY_CLOSED: 'Société fermée',
    COMPANY_HAS_A_MORAL_PERSON_AS_SHAREHOLDER:
      'Personne morale en tant qu’actionnaire',
    COMPANY_HAS_MORE_THAN_ONE_SHAREHOLDER: "Plus d'un bénéficiaire effectif",
    COMPANY_NOT_OWNED_BY_USER: "Société non dirigée par l'utilisateur",
    COMPANY_SITUATION_NOT_SUPPORTED: "Situation de l'entreprise non supportée",
    CUSTOM: 'Personnalisée',
    FORGED_DOCUMENT: 'Document(s) falsifié(s)',
    IDENTITY_THEFT: "Usurpation d'identité",
    LEGAL_FORM_NOT_SUPPORTED: 'Structure juridique non supportée',
    LOCATION_NOT_SUPPORTED: 'Zone non desservie',
    NO_ACTIVE_ESTABLISHMENT: 'Aucun établissement actif',
    SUSPICIOUS_BEHAVIOUR: 'Comportement suspect',
    SUSPICIOUS_CHANGE_OF_EXECUTIVES: 'Changement(s) de dirigeant(s) suspect(s)',
    SUSPICIOUS_RECENT_LIQUIDATIONS: 'Liquidations récentes suspectes',
    USER_NOT_ALLOWED_TO_WORK_IN_FRANCE: 'Pas autorisé à travailler en France',
    USER_TAX_RESIDENCY_COUNTRY_NOT_SUPPORTED:
      'Pays de résidence fiscale non supporté',
  },
};

const kycRefusalLocales = {
  en: {
    getLocalizedString: (tag) =>
      kycRefusalMessage.en[tag] || kycRefusalMessage.en.DEFAULT,
  },
  fr: {
    getLocalizedString: (tag) =>
      kycRefusalMessage.fr[tag] || kycRefusalMessage.fr.DEFAULT,
  },
};

/**
 * Get an URL and label to add to the refusal message
 * @return {Object}   - { label, url }
 */
const kycRefusalResources = {
  en: {
    getLocalizedUrl: (tag) =>
      kycRefusalUrls.en[tag] || kycRefusalUrls.en.DEFAULT,
  },
  fr: {
    getLocalizedUrl: (tag) =>
      kycRefusalUrls.fr[tag] || kycRefusalUrls.fr.DEFAULT,
  },
};

module.exports = {
  kycRefusalLocales,
  kycRefusalMessage,
  kycRefusalResources,
  kycRefusalTagLabel,
  kycRefusalTags,
  kycRefusalUrls,
  REFUSAL_TAGS,
};
